<!-- instagram -->
<div class="section section-instagram bg-white container-fluid d-none">

  <a class="section-anchor" name="section-instagram"></a>

  <div class="container-section">

    <div class="row align-items-stretch d-flex">

      <div class="col-12 col-sm-6 column-left  d-flex align-items-center justify-content-center">

        <div class="content text-center">

          <div class="logo-wrapper">
            <img class="logo-instagram" src="assets/img/logo/logo-instagram.png" />
          </div>

          <h2 class="alternate-heading">{{'Follow us also' | translate}}<br>
            {{'at' | translate}} <span class="text-primary">{{'instagram'}}</span>
          </h2>

          <p class="special-paragraph">
            <a target="_blank" href="https://www.instagram.com/meettheyoungsters/" class="instagram-link">&#64;meettheyoungsters</a>
          </p>

        </div>

      </div>

      <div class="col-12 col-sm-6 column-right d-flex align-items-center justify-content-center">

        <div class="grid grid-instagram feed-instagram" *ngIf="feed.instagramFeedData.length > 0">

          <div class="row align-items-center d-flex flex-wrap">

            <div class="grid-item-instagram col-6 col-md-4" *ngFor="let post of feed.instagramFeedData">
              <a class="post-link" target="_blank" [href]="post['permalink']">
                <div class="image-container" [ngStyle]="{'background-image' : 'url(' + post['media_url'] + ')'}"></div>
              </a>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
